// extracted by mini-css-extract-plugin
module.exports = {"link":"mission-link_link__hK0hw"};